import styled from 'styled-components';

export const SectionGrid = styled.section<{
  $max?: number;
}>`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  column-gap: 40px;
  width: 100%;
  max-width: 100%;
  margin: 0;

  @media (max-width: 1080px) {
    grid-template-columns: repeat(12, minmax(0, 1fr));
    column-gap: 16px;
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(8, minmax(0, 1fr));
    column-gap: 14px;
    padding: 0;
  }
`;

export const GridSpan = styled.div<{ start?: number; span?: number }>`
  grid-column: ${({ start = 1, span = 12 }) => `${start} / span ${span}`};
  width: 100%;

  & > * {
    max-width: 100% !important;
    margin: 0 auto !important;
  }

  @media (max-width: 768px) {
    grid-column: 1 / -1;
  }
`;
